import React, { useEffect, useState, useCallback } from "react";
import { Box, Typography, Button, Grid, Divider } from "@mui/material";
import { useParams, useNavigate } from "react-router-dom";
import { useIntl } from "react-intl";
import PeopleIcon from "@mui/icons-material/People";
import AppsIcon from "@mui/icons-material/Apps";
import HandshakeIcon from "@mui/icons-material/Handshake";
import FormatListBulletedIcon from "@mui/icons-material/FormatListBulleted";
import TransferWithinAStationIcon from "@mui/icons-material/TransferWithinAStation";
import { fetchDepartment } from "../../api/companyApi";
import { useNotification } from "../../providers/NotificationProvider";
import DetailSection from "../../components/common/DetailSection";
import DetailField from "../../components/common/DetailField";

export default function BuildDepartmentDetailPage() {
  const { businessDomainId, businessUnitId, departmentId } = useParams();
  const navigate = useNavigate();
  const intl = useIntl();
  const notify = useNotification();
  const t = (id) => intl.formatMessage({ id });
  const [data, setData] = useState(null);

  const basePath = `/build/${businessDomainId}/business-units/${businessUnitId}/departments/${departmentId}`;

  const loadData = useCallback(async () => {
    try { setData(await fetchDepartment(departmentId)); }
    catch (e) { notify.apiError(e); }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [departmentId]);

  useEffect(() => { loadData(); }, [loadData]);

  if (!data) return null;

  return (
    <Box>
      <Box sx={{ display: "flex", justifyContent: "space-between", alignItems: "center", mb: 2 }}>
        <Typography variant="h6">{t("department.detail.title")}</Typography>
      </Box>

      <DetailSection>
        <Grid container spacing={2}>
          <Grid size={12}>
            <DetailField label={t("department.name")} value={data.departmentName} />
          </Grid>
          <Grid size={12}>
            <DetailField label={t("department.job")} value={data.jobName} />
          </Grid>
          <Grid size={12}>
            <DetailField label={t("common.description")} value={data.departmentDescription} />
          </Grid>
        </Grid>
      </DetailSection>

      <Divider sx={{ my: 3 }} />
      <Box sx={{ display: "flex", flexDirection: "column", gap: 2 }}>
        {/* アクション一覧 */}
        <Box>
          <Button variant="outlined" startIcon={<FormatListBulletedIcon />}
            onClick={() => navigate(`${basePath}/actions`)}>
            {t("build.department.action.list.title")}
          </Button>
        </Box>
        {/* メンバー一覧　社員異動　市場メンバー異動 */}
        <Box sx={{ display: "flex", gap: 2, flexWrap: "wrap" }}>
          <Button variant="outlined" startIcon={<PeopleIcon />}
            onClick={() => navigate(`${basePath}/members`)}>
            {t("member.list.title")}
          </Button>
          <Button variant="outlined" startIcon={<TransferWithinAStationIcon />}
            onClick={() => navigate(`${basePath}/members/assign`)}>
            {t("build.department.member.move.company.title")}
          </Button>
          <Button variant="outlined" startIcon={<TransferWithinAStationIcon />}
            onClick={() => navigate(`${basePath}/members/move/market`)}>
            {t("build.department.member.move.market.title")}
          </Button>
        </Box>
        {/* アプリケーション一覧 */}
        <Box>
          <Button variant="outlined" startIcon={<AppsIcon />}
            onClick={() => navigate(`${basePath}/applications`)}>
            {t("build.department.application.list.title")}
          </Button>
        </Box>
        {/* パートナー一覧 */}
        <Box>
          <Button variant="outlined" startIcon={<HandshakeIcon />}
            onClick={() => navigate(`${basePath}/partners`)}>
            {t("build.department.partner.list.title")}
          </Button>
        </Box>
      </Box>

      <Box sx={{ mt: 3 }}>
        <Button variant="outlined" onClick={() => navigate(`/build/${businessDomainId}/business-units/${businessUnitId}/departments`)}>{t("common.back")}</Button>
      </Box>
    </Box>
  );
}
